import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M 28.541667,61
                    L 28.541667,30.3
                    L 39.291667,30.3
                    C 45.691667,30.3 49.691667,33.15 49.691667,38.65
                    C 49.691667,42.95 47.941667,45.95 39.291667,46.15
                    L 34.291667,46.15
                    L 34.291667,61
                    L 28.541667,61
                    Z
                    M 34.291667,42.2
                    L 34.291667,34.2
                    L 39.291667,34.2
                    C 43.691667,34.2 44.691667,35.15 44.691667,38.65
                    C 44.691667,41 43.691667,42.1 39.291667,42.2
                    L 34.291667,42.2
                    Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
